import ApiService from './ApiService';

export default {
  /**
   * Returns all marketplaces
   * @returns {Promise<any>}
   */
  all() {
    return new Promise((resolve, reject) => {
      const data = {
        limit: 1000,
      };
      ApiService.request('GET', 'marketplaces', data).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  /**
   * Finds a marketplace by specify ID
   * @param {number} id ID
   * @returns {Promise<any>}
   */
  findById(id) {
    return new Promise((resolve, reject) => {
      const data = {
        id,
        includes: 'language',
      };
      ApiService.request('GET', 'marketplaces', data).then((response) => {
        if (response.status === 200 && response.data.length === 1) {
          resolve(response.data[0]);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  /**
   * Update a marketplace
   * @param {number} id ID
   * @param {Object} data Data
   * @returns {Promise<any>}
   */
  update(id, data) {
    return new Promise((resolve, reject) => {
      ApiService.request('PUT', `marketplaces/${id}`, data).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(error => {
        reject(error);
      });
    });
  },
};
